<script lang="ts" setup>
import NotificationList from '~/components/lists/NotificationList.vue'

const config = useRuntimeConfig()
const toast = useToast()

const initWebSocket = () => {
  const baseUrl = config.public.baseURL
  baseUrl.replace('http://', 'ws://')
  baseUrl.replace('https://', 'wss://')

  const socket = new WebSocket(`${baseUrl}/ws/notifications/`)

  socket.onmessage = ({ data }) => {
    const object = JSON.parse(data) as components['schemas']['Notification']

    toast.add({
      detail: object.content,
      summary: object.subject ?? 'New notification',
      life: 5000,
      severity: 'info',
    })

    refresh()
  }
}

const props = defineProps<{
  organization: components['schemas']['Organization']
}>()
const pagination = ref({
  page: 1,
  per_page: 1,
})
const { data: objectList, refresh } = useApi<
  components['schemas']['PaginatedNotificationList']
>('/notifications/', {
  params: { ...pagination.value, status: 'delivered' },
})

const onOpenNotification = (
  notification: components['schemas']['Notification']
) => {
  if (!notification.url) return
  navigateTo(notification.url)
  refresh()
}

onMounted(() => {
  initWebSocket()
})
</script>

<template>
  <div class="relative">
    <button
      v-styleclass="{
        selector: '@next',
        enterFromClass: 'hidden',
        enterActiveClass: 'animate-scalein',
        leaveToClass: 'hidden',
        leaveActiveClass: 'animate-fadeout',
        hideOnOutsideClick: true,
      }"
      type="button"
      :aria-label="`Notifications (${objectList?.count ?? 0})`"
      class="layout-topbar-action"
    >
      <OverlayBadge
        :value="String(objectList?.count ?? 0)"
        severity="danger"
        size="small"
      >
        <i class="pi pi-bell"></i>
      </OverlayBadge>
    </button>
    <div
      data-scene="messages"
      class="config-panel hidden fixed inset-x-3 top-[4.25rem] sm:absolute sm:inset-x-auto sm:top-[3.25rem] sm:right-0 sm:w-96 p-4 bg-surface-0 dark:bg-surface-900 border border-surface rounded-border origin-top shadow-[0px_3px_5px_rgba(0,0,0,0.02),0px_0px_2px_rgba(0,0,0,0.05),0px_1px_4px_rgba(0,0,0,0.08)]"
    >
      <NotificationList @open="onOpenNotification" @read-all="refresh" />
    </div>
  </div>
</template>
